import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, Divider } from "@material-ui/core";

import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
    modalContent: {
        backgroundColor: theme.palette.primary.main,
    },
    texto: {
        color: theme.palette.secondary.dark,
    },
    texto2: {
        color: theme.palette.common.white,
    },
    modalActions: {
        backgroundColor: theme.palette.primary.main,
        paddingBottom: 20,
        paddingTop: 20,
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
    },
    textoHeader: {
        color: theme.palette.secondary.dark,
        fontWeight: "bold",
        fontSize: "14pt",
        textAlign: "center",
    },
    iconClose: {
        color: theme.palette.secondary.contrastText,
    },
    buttons: {
        width: 150,
        color: "#FFFFFF",
        fontSize: "12px",
        fontFamily: "Verdana Bold",
        borderRadius: 8,
        opacity: "200%",
        background: "linear-gradient(900deg, #F7D00E 30%, #A68A30 90%)",
        paddingTop: 8,
        paddingBottom: 8,
        "&:hover": {
            background: "#DFDFDF",
        },
    },
    divider: {
        height: "8px",
        backgroundColor: theme.palette.secondary.dark,
        width: "15%",
    },
}));

export default function ModalMensajes(props) {
    const classes = useStyles();
    const { openModal, setOpenModal, cuerpoModal } = props;

    return (
        <Dialog
            maxWidth="sm"
            open={openModal}
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    setOpenModal(false);
                }
            }}
            disableEscapeKeyDown={true}
            aria-labelledby="max-width-dialog-title"
            fullWidth
        >
            <DialogTitle id="max-width-dialog-title" className={classes.modalContent}>
                <Grid item container xs={12}>
                    <Grid item xs={12} container justify="center" alignItems="center">
                        <img
                            alt=""
                            src={require("../static/Identificador/Logo hotel dorado.svg")}
                            style={{
                                height: "100px",
                                width: "100px",
                                marginBottom: 10,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} container justify="center" alignItems="center">
                        <Typography className={classes.textoHeader} align="center">
                            <FormattedMessage id={cuerpoModal.tituloModal} />
                        </Typography>
                    </Grid>

                    <Grid item xs={12} container justify="center" alignItems="center">
                        <Divider className={classes.divider} />
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent className={classes.modalContent}>
                <Grid item xs={12} container justify="center" alignItems="center">
                    <Typography align="center" className={classes.texto2}>
                        {cuerpoModal.textoModal}
                    </Typography>
                </Grid>
            </DialogContent>
            <DialogActions className={classes.modalActions}>
                <Grid item container xs={12} justify="center" alignItems="center">
                    <Button
                        variant="contained"
                        onClick={() => {
                            try {
                                cuerpoModal.funcionBoton();
                            } catch (error) {}
                            setOpenModal(false);
                        }}
                        className={classes.buttons}
                    >
                        <FormattedMessage id="aceptar" />
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}
